const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0410156,0,0,0.0410156,11,11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard--2-",
    serifId: "dashboard (2)",
    transform: "matrix(1,0,0,1,-256,-256)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C115.04,0 0,115.049 0,256C0,396.96 115.049,512 256,512C396.96,512 512,396.951 512,256C512,115.04 396.951,0 256,0ZM256,482C131.383,482 30,380.617 30,256C30,131.383 131.383,30 256,30C380.617,30 482,131.383 482,256C482,380.617 380.617,482 256,482Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,452L331,452L331,361L181,361L181,452ZM211,391L301,391L301,422L211,422L211,391Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,60C148.201,60 60,148.214 60,256C60,349.352 124.943,399.158 128.721,404.493L181.754,351.46L160.541,330.247L129.169,361.619C107.117,335.469 93.806,304.093 90.706,271.001L136,271.001L136,241.001L90.685,241.001C93.792,206.476 107.509,174.965 128.55,149.765L160.54,181.755L181.753,160.542L149.763,128.552C174.964,107.511 206.474,93.794 240.999,90.687L240.999,136L270.999,136L270.999,90.685C305.524,93.792 337.035,107.509 362.235,128.55L330.245,160.54L351.458,181.753L383.448,149.763C404.489,174.964 418.206,206.474 421.313,240.999L376,240.999L376,270.989L421.294,270.989C418.194,304.08 404.883,335.467 382.831,361.617L351.459,330.245L330.246,351.458L383.279,404.491C387.047,399.171 452,349.366 452,256C452,148.201 363.786,60 256,60Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.03,274.497L297.417,273.639L323.671,188.329L238.359,214.582C238.259,214.669 211,225.284 211,256C211,280.813 231.187,301 256,301C273.659,301 289.765,290.597 297.03,274.497ZM241,256C241,250.372 244.17,245.216 249.14,242.654L278.329,233.671L269.346,262.861C266.784,267.83 261.629,271 256,271C247.729,271 241,264.271 241,256Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.62793d2c45417025cbfc50902e77be0c.svg";
export { ForwardRef as ReactComponent };